export default "__VITE_ASSET__DKGMSiHF__"